/* =========================================================
   sg-designer.js – Canvas-Designer mit Fabric.js
   Schwarzwald Gravur – Stand: April 2026

   Features:
   - Mehrere Gravurzonen pro Produkt (z.B. Hauptfläche + Griff)
   - Kunden wählen Zone vor der Gravur
   - Jede Zone: Rechteck, Oval oder Freihand-Polygon
   - Pixel-Processing: weißer Hintergrund → transparent, braun
   - SVG-Motive direkt in Gravur-Braun
   - Schriftgröße, Schriftart, Positionspresets
   - Logo-Upload (PNG + SVG)
   - Dynamischer Preis, Warenkorb + Cloudinary
   ========================================================= */

(function () {
  'use strict';

  /* ── Gravur-Farbe (Material-abhängig, wird in boot() gesetzt) ───
     material:'wood'  → Holzbrand-Braun (default)
     material:'glass' → Glasgravur-Weiß
     In sgDesignerConfig einfach material:'glass' angeben.
  ─────────────────────────────────────────────────────────── */
  var BURN_R = 68,  BURN_G = 32,  BURN_B = 7;   /* Holz-Default */
  var BURN_CSS  = 'rgba(68,32,7,0.88)';
  var BURN_CSS2 = 'rgba(90,44,10,0.78)';
  var BURN_IS_GLASS = false;   /* Pixel-Processing-Modus */

  /* ── Weiß-Entfernung ────────────────────────────────── */
  var WHITE_THRESH = 218;
  var CHROMA_MAX   = 45;

  /* ── Gravurzone-Rahmen ──────────────────────────────── */
  var ZONE_STROKE = 'rgba(200,57,26,0.55)';

  var FONT_DEFAULT = 'Georgia, "Times New Roman", serif';
  var DEBOUNCE_MS  = 280;

  var FONTS = [
    { label: 'Klassisch',      value: 'Georgia, "Times New Roman", serif' },
    { label: 'Elegant',        value: '"Playfair Display", Georgia, serif' },
    { label: 'Antik',          value: '"Cinzel", Georgia, serif' },
    { label: 'Schreibschrift', value: '"Great Vibes", "Brush Script MT", cursive' },
    { label: 'Handschrift',    value: '"Dancing Script", cursive' },
    { label: 'Locker',         value: '"Caveat", cursive' },
    { label: 'Modern',         value: 'Arial, Helvetica, sans-serif' },
    { label: 'Fett & Klar',   value: 'Impact, "Arial Narrow", sans-serif' },
  ];

  /* ── Motiv-Bibliothek (Kategorien) ──────────────────── */
  /* Wird automatisch von motiv-import.js generiert.
     Neue Motive: node motiv-import.js → Config hier ersetzen. */
  var MOTIV_KATEGORIEN = [
    {
      label: 'Berge',
      motive: [
        { name: 'Bergliebe-1', png: 'sg-motiv-berge-bergliebe-1.png' },
        { name: 'Bergliebe-2', png: 'sg-motiv-berge-bergliebe-2.png' },
        { name: 'Bergliebe-3', png: 'sg-motiv-berge-bergliebe-3.png' },
        { name: 'Bergliebe-4', png: 'sg-motiv-berge-bergliebe-4.png' },
        { name: 'Bergliebe-5', png: 'sg-motiv-berge-bergliebe-5.png' },
      ]
    },
    {
      label: 'Boy',
      motive: [
        { name: 'Boy-1',  png: 'sg-motiv-boy-1.png' },
        { name: 'Boy-2',  png: 'sg-motiv-boy-2.png' },
        { name: 'Boy-3',  png: 'sg-motiv-boy-3.png' },
        { name: 'Boy-4',  png: 'sg-motiv-boy-4.png' },
        { name: 'Boy-5',  png: 'sg-motiv-boy-5.png' },
        { name: 'Boy-6',  png: 'sg-motiv-boy-6.png' },
        { name: 'Boy-7',  png: 'sg-motiv-boy-7.png' },
        { name: 'Boy-8',  png: 'sg-motiv-boy-8.png' },
        { name: 'Boy-9',  png: 'sg-motiv-boy-9.png' },
        { name: 'Boy-10', png: 'sg-motiv-boy-10.png' },
      ]
    },
    {
      label: 'Girl',
      motive: [
        { name: 'Girl-1',  png: 'sg-motiv-girl-1.png' },
        { name: 'Girl-2',  png: 'sg-motiv-girl-2.png' },
        { name: 'Girl-3',  png: 'sg-motiv-girl-3.png' },
        { name: 'Girl-4',  png: 'sg-motiv-girl-4.png' },
        { name: 'Girl-5',  png: 'sg-motiv-girl-5.png' },
        { name: 'Girl-6',  png: 'sg-motiv-girl-6.png' },
        { name: 'Girl-7',  png: 'sg-motiv-girl-7.png' },
        { name: 'Girl-8',  png: 'sg-motiv-girl-8.png' },
        { name: 'Girl-9',  png: 'sg-motiv-girl-9.png' },
        { name: 'Girl-10', png: 'sg-motiv-girl-10.png' },
      ]
    },
    {
      label: 'Ski',
      motive: [
        { name: 'Ski-1', png: 'sg-motiv-ski-ski-1.png' },
        { name: 'Ski-2', png: 'sg-motiv-ski-ski-2.png' },
        { name: 'Ski-3', png: 'sg-motiv-ski-ski-3.png' },
        { name: 'Ski-4', png: 'sg-motiv-ski-ski-4.png' },
        { name: 'Ski-5', png: 'sg-motiv-ski-ski-5.png' },
      ]
    },
    {
      label: 'Wandern',
      motive: [
        { name: 'Wandern-1', png: 'sg-motiv-wandern-wandern-1.png' },
        { name: 'Wandern-2', png: 'sg-motiv-wandern-wandern-2.png' },
        { name: 'Wandern-3', png: 'sg-motiv-wandern-wandern-3.png' },
        { name: 'Wandern-4', png: 'sg-motiv-wandern-wandern-4.png' },
        { name: 'Wandern-5', png: 'sg-motiv-wandern-wandern-5.png' },
      ]
    },
    {
      label: 'Hochzeit',
      motive: [
        /* 🔲 Platzhalter – Motive noch nicht erstellt */
      ]
    },
    {
      label: 'Taufe',
      motive: [
        /* 🔲 Platzhalter – Motive noch nicht erstellt */
      ]
    },
    {
      label: 'Geburtstag',
      motive: [
        { name: 'Geburtstag-1',  png: 'sg-motiv-geburtstag-1.png' },
        { name: 'Geburtstag-2',  png: 'sg-motiv-geburtstag-2.png' },
        { name: 'Geburtstag-3',  png: 'sg-motiv-geburtstag-3.png' },
        { name: 'Geburtstag-4',  png: 'sg-motiv-geburtstag-4.png' },
        { name: 'Geburtstag-5',  png: 'sg-motiv-geburtstag-5.png' },
        { name: 'Geburtstag-6',  png: 'sg-motiv-geburtstag-6.png' },
        { name: 'Geburtstag-7',  png: 'sg-motiv-geburtstag-7.png' },
        { name: 'Geburtstag-8',  png: 'sg-motiv-geburtstag-8.png' },
        { name: 'Geburtstag-9',  png: 'sg-motiv-geburtstag-9.png' },
        { name: 'Geburtstag-10', png: 'sg-motiv-geburtstag-10.png' },
        { name: 'Geburtstag-11', png: 'sg-motiv-geburtstag-11.png' },
        { name: 'Geburtstag-12', png: 'sg-motiv-geburtstag-12.png' },
        { name: 'Geburtstag-13', png: 'sg-motiv-geburtstag-13.png' },
        { name: 'Geburtstag-14', png: 'sg-motiv-geburtstag-14.png' },
        { name: 'Geburtstag-15', png: 'sg-motiv-geburtstag-15.png' },
        { name: 'Geburtstag-16', png: 'sg-motiv-geburtstag-16.png' },
        { name: 'Geburtstag-17', png: 'sg-motiv-geburtstag-17.png' },
        { name: 'Geburtstag-18', png: 'sg-motiv-geburtstag-18.png' },
        { name: 'Geburtstag-19', png: 'sg-motiv-geburtstag-19.png' },
      ]
    },
    {
      label: 'Natur',
      motive: [
        /* 🔲 Platzhalter – Motive noch nicht erstellt */
      ]
    },
    {
      label: 'Vatertag',
      motive: [
        { name: 'Vatertag-1', png: 'sg-motiv-vatertag-1.png' },
        { name: 'Vatertag-2', png: 'sg-motiv-vatertag-2.png' },
        { name: 'Vatertag-3', png: 'sg-motiv-vatertag-3.png' },
        { name: 'Vatertag-4', png: 'sg-motiv-vatertag-4.png' },
        { name: 'Vatertag-5', png: 'sg-motiv-vatertag-5.png' },
        { name: 'Vatertag-6', png: 'sg-motiv-vatertag-6.png' },
        { name: 'Vatertag-7', png: 'sg-motiv-vatertag-7.png' },
        { name: 'Vatertag-8', png: 'sg-motiv-vatertag-8.png' },
      ]
    },
    {
      label: 'Muttertag',
      motive: [
        /* 🔲 Platzhalter – Motive noch nicht erstellt */
      ]
    },
    {
      label: 'Weihnachten',
      motive: [
        /* 🔲 Platzhalter – Motive noch nicht erstellt */
      ]
    },
  ];

  /* ── Motiv-Gruppen: steuern welche Kategorien bei ?motiv= sichtbar sind ──
     Jede Gruppe = thematisch verwandte Kategorien die gemeinsam angezeigt werden.
     Bei ?motiv=Ski → Outdoor-Gruppe → Ski + Berge + Wandern sichtbar, Ski aktiv.
     Bei ?motiv=Boy → Jungs-Gruppe → nur Boy sichtbar.
     Neue Gruppen hier eintragen wenn neue Kategorien dazukommen.
  ────────────────────────────────────────────────────────────────────────── */
  var MOTIV_GRUPPEN = [
    { gruppe: 'Outdoor',    kategorien: ['Berge', 'Ski', 'Wandern'] },
    { gruppe: 'Jungs',      kategorien: ['Boy'] },
    { gruppe: 'Maedchen',   kategorien: ['Girl'] },
    { gruppe: 'Hochzeit',   kategorien: ['Hochzeit'] },
    { gruppe: 'Taufe',      kategorien: ['Taufe'] },
    { gruppe: 'Geburtstag', kategorien: ['Geburtstag'] },
    { gruppe: 'Natur',      kategorien: ['Natur'] },
    /* Vatertag zeigt Outdoor + Boy – passende Motive für Väter */
    { gruppe: 'Vatertag',   kategorien: ['Berge', 'Ski', 'Wandern', 'Boy', 'Vatertag'] },
    { gruppe: 'Muttertag',  kategorien: ['Girl', 'Muttertag'] },
    { gruppe: 'Weihnachten',kategorien: ['Weihnachten'] },
  ];

  /* ── Motiv-Grid dynamisch aufbauen ───────────────────── */
  function buildMotivGrid(cfg) {
    var container = document.getElementById('sg-motiv-grid-wrap');
    if (!container || !MOTIV_KATEGORIEN.length) return;

    var assetBase    = (cfg && cfg.assetBase)    ? cfg.assetBase    : 'assets/';
    var assetVersion = (cfg && cfg.assetVersion) ? '?' + cfg.assetVersion : '';

    /* ── Schritt 1: ?motiv= URL-Parameter lesen ─────────────────────────
       Wenn gesetzt: passende MOTIV_GRUPPE finden → nur diese Kategorien
       anzeigen, den passenden Tab vorausgewählt.
       Beispiel: ?motiv=Ski → Outdoor-Gruppe → [Berge, Ski, Wandern], Ski aktiv.
    ────────────────────────────────────────────────────────────────────── */
    var urlMotiv = new URLSearchParams(window.location.search).get('motiv');
    var activeKatLabel = null;

    /* ── Schritt 1: Sichtbare Kategorien immer aus motivFilter ──────────
       motivFilter aus sg_designer.config bestimmt welche Tabs angezeigt
       werden — unabhängig vom ?motiv= URL-Parameter.
       Leer / nicht gesetzt = alle Kategorien anzeigen.
    ────────────────────────────────────────────────────────────────────── */
    var filter = (cfg && cfg.motivFilter && cfg.motivFilter.length) ? cfg.motivFilter : null;
    var kategorien = filter
      ? MOTIV_KATEGORIEN.filter(function (k) { return filter.indexOf(k.label) !== -1 && k.motive.length > 0; })
      : MOTIV_KATEGORIEN.filter(function (k) { return k.motive.length > 0; });
    if (!kategorien.length) kategorien = MOTIV_KATEGORIEN.filter(function (k) { return k.motive.length > 0; });

    /* ── Schritt 2: Aktiven Tab bestimmen ───────────────────────────────
       ?motiv=Geburtstag → Geburtstag-Tab vorauswählen (alle anderen Tabs
       bleiben sichtbar). Kein URL-Parameter → ersten Tab nehmen.
    ────────────────────────────────────────────────────────────────────── */
    if (urlMotiv) {
      /* Direkt als Kategorie-Label prüfen */
      kategorien.forEach(function (k) {
        if (k.label.toLowerCase() === urlMotiv.toLowerCase()) activeKatLabel = k.label;
      });
      /* Fallback: über MOTIV_GRUPPEN suchen (z.B. ?motiv=Ski → activeKatLabel='Ski') */
      if (!activeKatLabel) {
        MOTIV_GRUPPEN.forEach(function (g) {
          g.kategorien.forEach(function (k) {
            if (k.toLowerCase() === urlMotiv.toLowerCase()) {
              kategorien.forEach(function (mk) {
                if (mk.label === k) activeKatLabel = k;
              });
            }
          });
        });
      }
    }
    if (!activeKatLabel) activeKatLabel = kategorien.length ? kategorien[0].label : null;

    /* ── Schritt 3: Aktiven Tab-Index bestimmen ─────────────────────── */
    var activeIdx = 0;
    if (activeKatLabel) {
      kategorien.forEach(function (k, i) {
        if (k.label.toLowerCase() === activeKatLabel.toLowerCase()) activeIdx = i;
      });
    }

    /* ── Schritt 4: HTML aufbauen ────────────────────────────────────── */
    var html = '';

    /* Tabs nur wenn mehr als 1 Kategorie sichtbar */
    if (kategorien.length > 1) {
      html += '<div class="sg-motiv-tabs">';
      kategorien.forEach(function (kat, i) {
        html += '<button type="button" class="sg-motiv-tab' + (i === activeIdx ? ' sg-motiv-tab--active' : '') +
                '" data-kat="' + i + '">' + kat.label + '</button>';
      });
      html += '</div>';
    }

    /* Grid pro Kategorie */
    kategorien.forEach(function (kat, i) {
      html += '<div class="sg-motiv-grid" data-kat-grid="' + i + '"' +
              (i !== activeIdx ? ' style="display:none"' : '') + '>';
      kat.motive.forEach(function (m) {
        var src  = assetBase + (m.svg || m.png) + (m.png ? assetVersion : '');
        var attr = m.svg ? 'data-svg="' + src + '"' : 'data-img="' + src + '"';
        html += '<div class="sg-motiv-item" data-name="' + m.name + '" title="' + m.name + '" ' + attr + '>' +
                '<img src="' + src + '" alt="' + m.name + '" loading="lazy">' +
                '<span>' + m.name + '</span></div>';
      });
      html += '</div>';
    });

    container.innerHTML = html;

    /* ── Tab-Klick ───────────────────────────────────────────────────── */
    container.querySelectorAll('.sg-motiv-tab').forEach(function (tab) {
      tab.addEventListener('click', function () {
        container.querySelectorAll('.sg-motiv-tab').forEach(function (t) {
          t.classList.remove('sg-motiv-tab--active');
        });
        this.classList.add('sg-motiv-tab--active');
        var idx = this.dataset.kat;
        container.querySelectorAll('.sg-motiv-grid').forEach(function (g) {
          g.style.display = g.dataset.katGrid === idx ? '' : 'none';
        });
      });
    });
  }

  /* ── Bootstrap ──────────────────────────────────────── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* ═══════════════════════════════════════════════════════
     HAUPT-INIT
  ═══════════════════════════════════════════════════════ */
  function boot() {
    var cfg = window.sgDesignerConfig;
    if (!cfg) return;

    /* ── Material-Farben setzen ────────────────────────────────
       Reihenfolge: engravingColor (Hex) > material-Preset > wood-Default
    ─────────────────────────────────────────────────────────── */
    if (cfg.material === 'glass') {
      BURN_R = 255; BURN_G = 255; BURN_B = 255;
      BURN_CSS      = 'rgba(255,255,255,0.92)';
      BURN_CSS2     = 'rgba(240,240,240,0.85)';
      BURN_IS_GLASS = true;
    }
    /* engravingColor überschreibt alles (individuell / Windlicht etc.) */
    if (cfg.engravingColor) {
      var _hex = cfg.engravingColor.replace('#','');
      if (_hex.length === 6) {
        BURN_R = parseInt(_hex.substr(0,2), 16);
        BURN_G = parseInt(_hex.substr(2,2), 16);
        BURN_B = parseInt(_hex.substr(4,2), 16);
        var _a1 = BURN_R > 200 && BURN_G > 200 && BURN_B > 200 ? '0.92' : '0.88';
        var _a2 = BURN_R > 200 && BURN_G > 200 && BURN_B > 200 ? '0.82' : '0.75';
        BURN_CSS  = 'rgba('+BURN_R+','+BURN_G+','+BURN_B+','+_a1+')';
        BURN_CSS2 = 'rgba('+BURN_R+','+BURN_G+','+BURN_B+','+_a2+')';
        /* Pixel-Modus: helle Farbe = Glas-Logik (transparent nach Dunkelheit),
           dunkle Farbe = Holz-Logik (transparent nach Helligkeit)              */
        BURN_IS_GLASS = (BURN_R > 180 && BURN_G > 180 && BURN_B > 180);
      }
    }
    /* wood (default) bleibt wie initialisiert */

    var canvasEl = document.getElementById('sg-canvas');
    if (!canvasEl) return;

    var wrap = canvasEl.parentElement;
    var W    = Math.min(wrap.offsetWidth || 560, 640);

    /* Canvas-Höhe aus echtem Bildseitenverhältnis berechnen → Zone sitzt pixel-perfekt */
    function init(H) {

    canvasEl.width  = W;
    canvasEl.height = H;

    var fc = new fabric.Canvas('sg-canvas', {
      selection:              false,
      preserveObjectStacking: true,
    });
    fc.setWidth(W);
    fc.setHeight(H);

    /* ── Zonen laden ────────────────────────────────────── */
    var zonesRaw = cfg.zones || [cfg.zone || defaultZone()];
    var zones    = zonesRaw.map(function (z) { return buildZone(z, W, H); });
    var activeZoneIdx = 0;

    function activeZone() { return zones[activeZoneIdx]; }

    /* ── SVG-Pfade für Sonderformen vorladen (async, fire-and-forget) ── */
    preloadZonePaths(cfg.svgClip, zones, W, H, fc);

    /* ── Hintergrund ────────────────────────────────────── */
    loadBg(cfg.productImage, W, H, function (img) {
      if (!img) return;
      img.set({ selectable: false, evented: false, hoverCursor: 'default' });
      fc.add(img);
      fc.sendToBack(img);
      renderAllZoneBorders(fc, zones, activeZoneIdx);
      fc.renderAll();
    });

    /* ── Clip-Path für aktive Zone ─────────────────────── */
    function makeClip() { return buildClip(activeZone()); }

    /* ── Zonen-Auswahl UI ──────────────────────────────── */
    buildZoneSelector(zones, activeZoneIdx, function (idx) {
      activeZoneIdx = idx;
      renderAllZoneBorders(fc, zones, activeZoneIdx);
      /* Text/Motiv auf neue Zone verschieben */
      if (nameObj)  moveToZone(nameObj,  activeZone(), mode, 'text',  fc);
      if (motivObj) moveToZone(motivObj, activeZone(), mode, 'motiv', fc);
      if (nameObj)  nameObj.clipPath  = makeClip();
      if (motivObj) motivObj.clipPath = makeClip();
      fc.renderAll();
    });

    /* ── Zustand ────────────────────────────────────────── */
    var mode          = 'ohne';
    var nameObj       = null;
    var motivObj      = null;
    var activeMotivEl = null;
    var textState = { fontSize: Math.round(H * 0.10), fontFamily: FONT_DEFAULT, outline: false, align: 'center', lineHeight: 1.25 };

    /* ── Windlicht-Erweiterungen ────────────────────────────────────────────
       positionMode:'free'  → freies Drag (Vesperbrett-Standard, unverändert)
       positionMode:'fixed' → nur Oben/Mitte/Unten Snap-Buttons, kein Drag
       selectedColor        → aktiver Farb-Key für 2D variantMap
       isBeidseitig         → Beidseitig-Aufpreis aktiv (+€3)
    ──────────────────────────────────────────────────────────────────────── */
    var positionMode  = cfg.positionMode || 'free';
    var selectedColor = (cfg.colors && cfg.colors.length) ? cfg.colors[0].key : null;
    var isBeidseitig  = false;

    /* ── Drag-Wrapper: respektiert positionMode ─────────────────────────── */
    function setupDrag(obj) {
      if (positionMode === 'fixed') {
        /* fixed: kein freies Verschieben — Position via Snap-Buttons */
        obj.set({
          selectable:  false,
          hasControls: false,
          hasBorders:  false,
          evented:     false,
          hoverCursor: 'default',
        });
      } else {
        attachDrag(fc, obj, activeZone);
      }
    }

    /* ── Snap-Positionen (Windlicht: Oben/Mitte/Unten) ─────────────────── */
    function snapToPosition(pos) {
      var zone   = activeZone();
      var yRatio = { top: 0.22, center: 0.50, bottom: 0.78 };
      var yR     = yRatio[pos] != null ? yRatio[pos] : 0.50;
      var targetY = zone.top + zone.height * yR;
      [nameObj, nameObj2, motivObj].forEach(function (obj) {
        if (!obj) return;
        obj.set({ left: zone.cx, top: targetY });
        obj.setCoords();
      });
    }

    /* ── Schriftart als Bestelldetail mitschreiben ───────── */
    function sgFontLabel(sel){ if(!sel||sel.selectedIndex<0) return ''; var o=sel.options[sel.selectedIndex]; return o?o.textContent:''; }
    function sgPrimaryFont(v){ return (v||'').split(',')[0].replace(/["']/g,'').trim(); }
    function syncFontProps(){
      var n=document.getElementById('sg-prop-name'), n2=document.getElementById('sg-prop-name2');
      var fp=document.getElementById('sg-prop-font'), fp2=document.getElementById('sg-prop-font2');
      var s=document.getElementById('sg-font-select'), s2=document.getElementById('sg-font2-select');
      if(fp)  fp.value  = (n  && n.value)  ? (sgFontLabel(s)  + ' (' + sgPrimaryFont(s  && s.value)  + ')') : '';
      if(fp2) fp2.value = (n2 && n2.value) ? (sgFontLabel(s2) + ' (' + sgPrimaryFont(s2 && s2.value) + ')') : '';
    }

    /* ── Schriftart ─────────────────────────────────────── */
    var fontSel = document.getElementById('sg-font-select');
    if (fontSel) {
      FONTS.forEach(function (f) {
        var o = document.createElement('option');
        o.value = f.value; o.textContent = f.label;
        o.selected = (f.value === FONT_DEFAULT);
        fontSel.appendChild(o);
      });
      fontSel.addEventListener('change', function () {
        var chosen = this.value;
        textState.fontFamily = chosen;
        syncFontProps();
        if (!nameObj) return;
        /* Schrift ggf. erst laden, dann rendern */
        document.fonts.load('40px ' + chosen).then(function () {
          if (textState.outline) {
            rebuildNameObj(nameObj.sgText || '', nameObj.left, nameObj.top,
                           nameObj.angle, nameObj.scaleX, nameObj.scaleY);
          } else {
            nameObj.set({ fontFamily: chosen });
            fc.renderAll();
          }
        });
      });
    }

    /* ── Helfer: nameObj an bestehender Position neu aufbauen ── */
    function rebuildNameObj(text, left, top, angle, sx, sy) {
      if (nameObj) { fc.remove(nameObj); nameObj = null; }
      if (!text) { fc.renderAll(); return; }
      buildNameText(text, activeZone(), mode, textState, makeClip, function (obj) {
        nameObj = obj;
        nameObj.set({ left: left, top: top, angle: angle, scaleX: sx, scaleY: sy });
        nameObj.setCoords();
        fc.add(nameObj);
        setupDrag(nameObj);
        fc.renderAll();
      });
    }

    /* ── Stil-Buttons (Normal / Kontur) ─────────────────── */
    document.querySelectorAll('.sg-style-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        document.querySelectorAll('.sg-style-btn').forEach(function (b) {
          b.classList.remove('sg-style-btn--active');
        });
        this.classList.add('sg-style-btn--active');
        textState.outline = (this.dataset.style === 'outline');
        /* Debug-Panel ausblenden */
        var dbg = document.getElementById('sg-debug');
        if (dbg) dbg.style.display = 'none';
        if (nameObj) {
          rebuildNameObj(nameObj.sgText || '', nameObj.left, nameObj.top,
                         nameObj.angle, nameObj.scaleX, nameObj.scaleY);
        }
      });
    });

    /* ── Ausrichtungs-Buttons (Links / Mitte / Rechts) ─── */
    document.querySelectorAll('.sg-align-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        document.querySelectorAll('.sg-align-btn').forEach(function (b) {
          b.classList.remove('sg-align-btn--active');
        });
        this.classList.add('sg-align-btn--active');
        textState.align = this.dataset.align;
        if (nameObj && !nameObj.sgIsKontur) {
          /* Nur textAlign updaten — Text bleibt an seiner Position */
          nameObj.set({ textAlign: this.dataset.align });
          fc.renderAll();
        }
      });
    });

    /* ── Gravur-Optionen (Toggle-Karten) ───────────────── */
    var hasText  = false;
    var hasMotiv = false;
    var hasLogo  = false;

    function computeMode() {
      /* Eigenes Motiv (Logo-Upload): flat-Preis, Name inklusive */
      if (hasLogo)             return 'logo';
      if (hasText && hasMotiv) return 'name_motiv';
      if (hasText)             return 'name';
      if (hasMotiv)            return 'motiv';
      return 'ohne';
    }

    /* ── Motiv-Grid zurücksetzen (nach Deaktivieren oder "ändern") ── */
    function resetMotivGrid() {
      var chosenEl = document.getElementById('sg-motiv-chosen');
      var motivHint = document.getElementById('sg-motiv-hint');
      if (motivWrap) motivWrap.style.display = '';
      if (chosenEl)  chosenEl.style.display  = 'none';
      if (motivHint) motivHint.style.display = '';
    }

    function applyToggleMode() {
      mode = computeMode();
      /* Sektionen direkt nach Toggle-Zustand steuern — nicht nach Mode */
      tog('sg-name-section',  hasText);
      tog('sg-motiv-section', hasMotiv);
      tog('sg-logo-section',  hasLogo);
      tog('sg-text-controls', hasText);
      /* Motiv-Grid zurücksetzen wenn kein Preset-Motiv aktiv ODER wenn Logo aktiv ist
         (Logo ersetzt das Preset-Motiv visuell → .sg-motiv-chosen soll verschwinden) */
      if (!hasMotiv || hasLogo) resetMotivGrid();
      var wantName  = hasText;
      var wantMotiv = hasMotiv || hasLogo;
      if (!wantName  && nameObj)  { fc.remove(nameObj);  nameObj  = null; }
      if (!wantName  && nameObj2) { fc.remove(nameObj2); nameObj2 = null; }
      if (!wantMotiv && motivObj) { fc.remove(motivObj); motivObj = null;
        if (activeMotivEl) { activeMotivEl.classList.remove('sg-motiv-item--active'); activeMotivEl = null; }
      }
      fc.renderAll();
      updatePrice(cfg, mode, hasText, selectedColor, isBeidseitig);
    }

    var toggleCards = document.querySelectorAll('.sg-toggle-card');
    if (toggleCards.length) {
      /* Neues Toggle-Karten-System — Logo & Preset-Motiv schließen sich gegenseitig aus */
      /* Google Fonts lazy loading — wird nur beim ersten Text-Toggle geladen */
      var _fontsLoaded = false;
      function loadGoogleFonts() {
        if (_fontsLoaded) return;
        _fontsLoaded = true;
        var preC = document.createElement('link');
        preC.rel = 'preconnect'; preC.href = 'https://fonts.googleapis.com';
        document.head.appendChild(preC);
        var preG = document.createElement('link');
        preG.rel = 'preconnect'; preG.href = 'https://fonts.gstatic.com'; preG.crossOrigin = '';
        document.head.appendChild(preG);
        var link = document.createElement('link');
        link.rel  = 'stylesheet';
        link.href = 'https://fonts.googleapis.com/css2?family=Playfair+Display&family=Cinzel&family=Great+Vibes&family=Dancing+Script&family=Caveat&display=swap';
        document.head.appendChild(link);
      }

      toggleCards.forEach(function (card) {
        card.addEventListener('click', function () {
          var type = this.dataset.type;
          if (type === 'text') {
            hasText = !hasText;
            if (hasText) loadGoogleFonts();
          } else if (type === 'motiv') {
            hasMotiv = !hasMotiv;
            if (hasMotiv) hasLogo = false;   // Preset-Motiv deaktiviert Logo
          } else if (type === 'logo') {
            hasLogo = !hasLogo;
            if (hasLogo) hasMotiv = false;   // Logo deaktiviert Preset-Motiv
          }
          document.getElementById('toggle-text') .classList.toggle('sg-toggle-card--active', hasText);
          document.getElementById('toggle-motiv').classList.toggle('sg-toggle-card--active', hasMotiv);
          document.getElementById('toggle-logo') .classList.toggle('sg-toggle-card--active', hasLogo);
          applyToggleMode();
        });
      });
    } else {
      /* Fallback: klassische Radio-Buttons (sg-produkt-designer.liquid) */
      document.querySelectorAll('input[name="gravur"]').forEach(function (r) {
        r.addEventListener('change', function () {
          mode = this.value;
          highlightOpt(this);
          showSections(mode);
          toggleTextControls(mode);
          var wantName  = mode === 'name' || mode === 'name_motiv' || mode === 'logo';
          var wantMotiv = mode === 'motiv' || mode === 'name_motiv' || mode === 'logo';
          if (!wantName  && nameObj)  { fc.remove(nameObj);  nameObj  = null; }
          if (!wantMotiv && motivObj) { fc.remove(motivObj); motivObj = null;
            if (activeMotivEl) { activeMotivEl.classList.remove('sg-motiv-item--active'); activeMotivEl = null; }
          }
          fc.renderAll();
          updatePrice(cfg, mode, hasText, selectedColor, isBeidseitig);
        });
      });
    }

    /* ── Name-Eingabe ───────────────────────────────────── */
    var nameTimer = null;
    var nameInput = document.getElementById('sg-name-input');
    if (nameInput) {
      nameInput.addEventListener('input', function () {
        clearTimeout(nameTimer);
        var val = this.value;

        /* Kontur-Button deaktivieren wenn mehrzeilig */
        var isMulti = val.indexOf('\n') !== -1;
        var outlineBtn = document.getElementById('sg-style-outline');
        var solidBtn   = document.getElementById('sg-style-solid');
        if (outlineBtn) {
          outlineBtn.disabled = isMulti;
          outlineBtn.style.opacity = isMulti ? '0.4' : '';
          outlineBtn.title = isMulti ? 'Kontur nur für einzeiligen Text' : '';
          if (isMulti && textState.outline) {
            textState.outline = false;
            outlineBtn.classList.remove('sg-style-btn--active');
            if (solidBtn) solidBtn.classList.add('sg-style-btn--active');
          }
        }

        /* Zeilenabstand + Ausrichtung nur bei mehrzeiligem Text */
        var lhRow    = document.getElementById('sg-lineheight-row');
        var alignRow = document.getElementById('sg-align-row');
        if (lhRow)    lhRow.style.display    = isMulti ? '' : 'none';
        if (alignRow) alignRow.style.display = isMulti ? '' : 'none';

        nameTimer = setTimeout(function () {
          if (nameObj) { fc.remove(nameObj); nameObj = null; }
          document.getElementById('sg-prop-name').value = val;
          syncFontProps();
          if (!val) { fc.renderAll(); return; }
          buildNameText(val, activeZone(), mode, textState, makeClip, function (obj) {
            nameObj = obj;
            fc.add(nameObj);
            setupDrag(nameObj);
            fc.renderAll();
          });
        }, DEBOUNCE_MS);
      });
    }

    /* ── Zeilenabstand-Buttons ─────────────────────────── */
    document.querySelectorAll('.sg-lh-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var lh = parseFloat(this.dataset.lh);
        textState.lineHeight = lh;
        document.querySelectorAll('.sg-lh-btn').forEach(function (b) {
          b.classList.toggle('sg-style-btn--active', b === btn);
        });
        /* Direkt auf vorhandenem Text-Objekt aktualisieren */
        if (nameObj && !nameObj.sgIsKontur) {
          nameObj.set({ lineHeight: lh });
          nameObj.setCoords();
          fc.renderAll();
        } else if (nameObj && nameObj.sgIsKontur) {
          /* Kontur ist ein Bild — bei Einzelzeile kein Effekt, ignorieren */
        }
      });
    });

    /* ── Zweiter Text ───────────────────────────────────── */
    var nameObj2   = null;
    var nameTimer2 = null;
    var textState2 = { fontSize: Math.round(H * 0.08), fontFamily: FONT_DEFAULT, outline: false, align: 'center', lineHeight: 1.25 };

    /* Font-Select für Text 2 befüllen */
    var fontSel2 = document.getElementById('sg-font2-select');
    if (fontSel2) {
      FONTS.forEach(function (f) {
        var o = document.createElement('option');
        o.value = f.value; o.textContent = f.label;
        o.selected = (f.value === FONT_DEFAULT);
        fontSel2.appendChild(o);
      });
      fontSel2.addEventListener('change', function () {
        var chosen = this.value;
        textState2.fontFamily = chosen;
        syncFontProps();
        if (!nameObj2) return;
        document.fonts.load('40px ' + chosen).then(function () {
          nameObj2.set({ fontFamily: chosen });
          fc.renderAll();
        });
      });
    }

    /* Textarea Text 2 */
    var nameInput2 = document.getElementById('sg-name2-input');
    if (nameInput2) {
      nameInput2.addEventListener('input', function () {
        clearTimeout(nameTimer2);
        var val = this.value;
        nameTimer2 = setTimeout(function () {
          if (nameObj2) { fc.remove(nameObj2); nameObj2 = null; }
          document.getElementById('sg-prop-name2').value = val;
          syncFontProps();
          if (!val) { fc.renderAll(); return; }
          buildNameText(val, activeZone(), mode, textState2, makeClip, function (obj) {
            nameObj2 = obj;
            /* Leicht versetzt starten damit er nicht exakt auf Text 1 liegt */
            if (nameObj2) nameObj2.set({ top: nameObj2.top + Math.round(H * 0.12) });
            nameObj2.setCoords();
            fc.add(nameObj2);
            setupDrag(nameObj2);
            fc.renderAll();
          });
        }, DEBOUNCE_MS);
      });
    }

    /* + Zweiten Text hinzufügen */
    var addText2Btn = document.getElementById('sg-add-text2');
    var name2Section = document.getElementById('sg-name2-section');
    if (addText2Btn) {
      addText2Btn.addEventListener('click', function () {
        addText2Btn.style.display = 'none';
        if (name2Section) name2Section.style.display = '';
        if (nameInput2) nameInput2.focus();
      });
    }

    /* ✕ Entfernen */
    var removeText2Btn = document.getElementById('sg-remove-text2');
    if (removeText2Btn) {
      removeText2Btn.addEventListener('click', function () {
        if (nameObj2) { fc.remove(nameObj2); nameObj2 = null; }
        if (nameInput2) nameInput2.value = '';
        document.getElementById('sg-prop-name2').value = '';
        syncFontProps();
        if (name2Section) name2Section.style.display = 'none';
        if (addText2Btn) addText2Btn.style.display = '';
        fc.renderAll();
      });
    }

    /* ── Motiv-Grid bauen ───────────────────────────────── */
    buildMotivGrid(cfg);

    /* URL-Parameter ?motiv= wird jetzt direkt in buildMotivGrid() verarbeitet —
       Gruppen-Filter + Tab-Vorauswahl passieren dort. */

    /* ── Positions-Snap (Windlicht – positionMode:'fixed') ─────────────────
       Zeigt #sg-position-section mit drei Buttons: Oben / Mitte / Unten.
       Bei positionMode:'free' (Vesperbretter) bleibt die Section versteckt.
    ──────────────────────────────────────────────────────────────────────── */
    var posSection = document.getElementById('sg-position-section');
    if (positionMode === 'fixed') {
      if (posSection) posSection.style.display = '';
      /* Mitte vorauswählen als Standard */
      var defaultPosBtn = document.querySelector('.sg-pos-btn[data-pos="center"]');
      if (defaultPosBtn) defaultPosBtn.classList.add('sg-pos-btn--active');

      document.querySelectorAll('.sg-pos-btn').forEach(function (btn) {
        btn.addEventListener('click', function () {
          document.querySelectorAll('.sg-pos-btn').forEach(function (b) {
            b.classList.remove('sg-pos-btn--active');
          });
          this.classList.add('sg-pos-btn--active');
          snapToPosition(this.dataset.pos);
          fc.renderAll();
        });
      });
    } else {
      if (posSection) posSection.style.display = 'none';
    }

    /* ── Beidseitig-Toggle (+€3) ────────────────────────────────────────────
       Checkbox #sg-beidseitig-toggle — sichtbar für alle Produkte mit
       cfg.aufpreise.beidseitig gesetzt. Preis wird in updatePrice() addiert.
    ──────────────────────────────────────────────────────────────────────── */
    var beidseitigToggle = document.getElementById('sg-beidseitig-toggle');
    if (beidseitigToggle) {
      beidseitigToggle.addEventListener('change', function () {
        isBeidseitig = this.checked;
        var prop = document.getElementById('sg-prop-beidseitig');
        if (prop) prop.value = isBeidseitig ? 'Ja (+€3,00)' : '';
        var propAufpreis = document.getElementById('sg-prop-beidseitig-aufpreis');
        if (propAufpreis) propAufpreis.value = isBeidseitig ? '300' : '';
        updatePrice(cfg, mode, hasText, selectedColor, isBeidseitig);
      });
    }

    /* ── Farb-Selektor (Windlicht: 7 Farbkombinationen) ────────────────────
       cfg.colors = [{ key, label, hexOut, hexIn }]
       Sichtbar nur wenn cfg.colors vorhanden — Vesperbretter sind unberührt.
    ──────────────────────────────────────────────────────────────────────── */
    if (cfg.colors && cfg.colors.length) {
      buildColorSelector(cfg, selectedColor, function (key) {
        selectedColor = key;
        updatePrice(cfg, mode, hasText, selectedColor, isBeidseitig);
      });
    }

    /* ── Motiv-Picker (Event-Delegation auf dem Container) ── */
    var motivWrap = document.getElementById('sg-motiv-grid-wrap');
    if (motivWrap) {
      motivWrap.addEventListener('click', function (e) {
        var item = e.target.closest('.sg-motiv-item');
        if (!item) return;
        if (activeMotivEl) activeMotivEl.classList.remove('sg-motiv-item--active');
        item.classList.add('sg-motiv-item--active');
        activeMotivEl = item;
        document.getElementById('sg-prop-motiv').value = item.dataset.name || '';

        /* Kompakte Vorschau zeigen, Grid ausblenden */
        var chosenEl   = document.getElementById('sg-motiv-chosen');
        var chosenImg  = document.getElementById('sg-motiv-chosen-img');
        var chosenName = document.getElementById('sg-motiv-chosen-name');
        var motivHint  = document.getElementById('sg-motiv-hint');
        if (chosenEl && chosenImg && chosenName) {
          chosenImg.src = item.dataset.img || item.dataset.svg || '';
          chosenName.textContent = item.dataset.name || '';
          motivWrap.style.display = 'none';
          chosenEl.style.display  = '';
          if (motivHint) motivHint.style.display = 'none';
        }

        if (motivObj) { fc.remove(motivObj); motivObj = null; }
        var svgUrl  = item.dataset.svg;
        var imgSrc  = item.dataset.img;
        var done = function (o) {
          motivObj = o;
          fc.add(motivObj);
          setupDrag(motivObj);
          fc.setActiveObject(motivObj);
          fc.renderAll();
        };
        if (svgUrl)      loadSVGMotiv(svgUrl, activeZone(), mode, makeClip, done);
        else if (imgSrc) loadImgMotiv(imgSrc, activeZone(), mode, makeClip, done);
      });
    }

    /* ── Motiv-Vorschau: "ändern"-Button ─────────────────── */
    var motivChosenChange = document.getElementById('sg-motiv-chosen-change');
    if (motivChosenChange) {
      motivChosenChange.addEventListener('click', function () {
        resetMotivGrid();
      });
    }

    /* Alte statische Items entfernt — alles läuft jetzt über
       Event-Delegation auf sg-motiv-grid-wrap (buildMotivGrid) */

    /* ── Logo-Upload ────────────────────────────────────── */
    var logoFile    = document.getElementById('sg-logo-file');
    var logoUpload  = document.getElementById('sg-logo-upload');
    var logoPreview = document.getElementById('sg-logo-preview');
    var logoPreviewImg  = document.getElementById('sg-logo-preview-img');
    var logoPreviewName = document.getElementById('sg-logo-preview-name');
    var logoChange  = document.getElementById('sg-logo-change');

    function showLogoPreview(file) {
      if (!logoUpload || !logoPreview) return;
      logoPreviewImg.src  = URL.createObjectURL(file);
      logoPreviewName.textContent = file.name.length > 28
        ? file.name.slice(0, 26) + '…'
        : file.name;
      logoUpload.style.display  = 'none';
      logoPreview.style.display = '';
    }

    if (logoChange) {
      logoChange.addEventListener('click', function () {
        if (logoUpload)  logoUpload.style.display  = '';
        if (logoPreview) logoPreview.style.display = 'none';
        if (logoFile)    logoFile.value = '';
      });
    }

    if (logoFile) {
      logoFile.addEventListener('change', function (e) {
        var file = e.target.files[0];
        if (!file) return;

        /* Original sofort zu Cloudinary hochladen (volle Qualität, vor Pixel-Processing) */
        var originalProp = document.getElementById('sg-prop-logo-original');
        if (originalProp) originalProp.value = '';   /* reset */
        if (cfg.cloudinaryCloud) {
          setStatus('info', '↑ Originaldatei wird gespeichert …');
          uploadCldFile(file, cfg)
            .then(function (url) {
              if (originalProp) originalProp.value = url;
              setStatus('ok', '✓ Originaldatei gespeichert');
            })
            .catch(function () {
              setStatus('err', 'Original konnte nicht gespeichert werden');
            });
        }

        var reader = new FileReader();
        reader.onload = function (ev) {
          if (motivObj) { fc.remove(motivObj); motivObj = null; }
          if (file.type === 'image/svg+xml') {
            fabric.loadSVGFromString(ev.target.result, function (objects, options) {
              burnSVGObjects(objects);
              var grp = fabric.util.groupSVGElements(objects, options);
              placeCenter(grp, activeZone(), 0.50);
              grp.set({ opacity: 0.90, clipPath: makeClip() });
              applyHandles(grp);
              motivObj = grp;
              fc.add(motivObj);
              setupDrag(motivObj);
              fc.setActiveObject(motivObj); fc.renderAll();
            });
          } else {
            loadAndBurnImage(ev.target.result, false, function (img) {
              placeCenter(img, activeZone(), 0.50);
              img.set({ clipPath: makeClip() });
              applyHandles(img);
              motivObj = img;
              fc.add(motivObj);
              setupDrag(motivObj);
              fc.setActiveObject(motivObj); fc.renderAll();
            });
          }
          showLogoPreview(file);
        };
        reader.readAsDataURL(file);
      });
    }

    /* ── Warenkorb ──────────────────────────────────────── */
    var form = document.getElementById('sg-form');
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = document.getElementById('sg-atc-btn');
        btn.disabled    = true;
        btn.textContent = 'Vorschau wird gespeichert …';
        fc.discardActiveObject(); fc.renderAll();

        /* Zone-Name in Properties speichern */
        var zprop = document.getElementById('sg-prop-zone');
        if (zprop) zprop.value = activeZone().name || '';

        var dataUrl = null;
        /* Hochauflösender Export (~1500 px breit) — unabhängig von Bildschirm/Mobil,
           damit die Gravur-Vorlage gross genug für die Produktion ist. */
        var _cw   = (fc.getWidth && fc.getWidth()) || fc.width || 600;
        var _mult = Math.max(1, Math.min(6, 1500 / _cw));
        try { dataUrl = fc.toDataURL({ format: 'png', quality: 0.92, multiplier: _mult }); }
        catch (err) { console.warn('[sg-designer] toDataURL CORS:', err); }

        if (dataUrl && cfg.cloudinaryCloud) {
          uploadCld(dataUrl, cfg)
            .then(function (url) {
              document.getElementById('sg-prop-preview').value = url;
              setStatus('ok', '✓ Vorschau gespeichert');
              cartSubmit(form, btn);
            }).catch(function () { cartSubmit(form, btn); });
        } else { cartSubmit(form, btn); }
      });
    }
    } /* end init(H) */

    /* Bild vorladen → Seitenverhältnis bestimmen → init starten */
    if (cfg.productImage) {
      var preImg    = new Image();
      preImg.onload = function () {
        var ratio = preImg.naturalHeight && preImg.naturalWidth
          ? preImg.naturalHeight / preImg.naturalWidth : 0.625;
        init(Math.round(W * ratio));
      };
      preImg.onerror = function () { init(Math.round(W * 0.625)); };
      preImg.src = cfg.productImage;
    } else {
      init(Math.round(W * 0.625));
    }
  }

  /* ═══════════════════════════════════════════════════════
     ZONEN-SYSTEM
  ═══════════════════════════════════════════════════════ */

  function defaultZone() {
    return { name: 'Gravurbereich', shape: 'rect', xR: 0.12, yR: 0.12, wR: 0.76, hR: 0.76 };
  }

  /* Zonen-Objekt aus relativen Prozent-Werten berechnen */
  function buildZone(z, W, H) {
    var zone = {
      id:     z.id    || 'zone',
      name:   z.name  || 'Gravurbereich',
      shape:  z.shape || 'rect',
      rx:     z.rx    != null ? z.rx : 14,
      left:   W * (z.xR || 0.12),
      top:    H * (z.yR || 0.12),
      width:  W * (z.wR || 0.76),
      height: H * (z.hR || 0.76),
    };
    zone.cx = zone.left + zone.width  / 2;
    zone.cy = zone.top  + zone.height / 2;

    /* SVG-Pfad direkt aus Metafeld (pathD + vbW/vbH) – kein Fetch nötig */
    if (z.shape === 'svg-path' && z.pathD && z.vbW && z.vbH) {
      zone._svgPathD  = z.pathD;
      zone._svgScaleX = W / z.vbW;
      zone._svgScaleY = H / z.vbH;
    }

    return zone;
  }

  /* Zonen-Rahmen — nur bei mehreren Zonen anzeigen, bei einer Zone unsichtbar */
  function renderAllZoneBorders(fc, zones, activeIdx) {
    /* Alte Rahmen entfernen */
    fc.getObjects().forEach(function (o) {
      if (o._sgZoneBorder) fc.remove(o);
    });

    /* Bei nur einer Zone: kein Rahmen, kein Label nötig */
    if (zones.length <= 1) return;

    zones.forEach(function (zone, i) {
      var isActive  = (i === activeIdx);
      var dashArray = isActive ? [8, 4] : [4, 6];
      var alpha     = isActive ? 0.60 : 0.22;
      var stroke    = isActive
        ? 'rgba(200,57,26,' + alpha + ')'
        : 'rgba(150,150,150,' + alpha + ')';

      var common = {
        fill:            'transparent',
        stroke:          stroke,
        strokeWidth:     isActive ? 1.8 : 1.2,
        strokeDashArray: dashArray,
        selectable:      false,
        evented:         false,
        hoverCursor:     'default',
        _sgZoneBorder:   true,
      };

      var border;
      if (zone.shape === 'oval') {
        border = new fabric.Ellipse(Object.assign({}, common, {
          left: zone.cx, top: zone.cy, rx: zone.width / 2, ry: zone.height / 2,
          originX: 'center', originY: 'center',
        }));
      } else {
        border = new fabric.Rect(Object.assign({}, common, {
          left: zone.left, top: zone.top, width: zone.width, height: zone.height,
          rx: zone.rx, ry: zone.rx,
        }));
      }
      border._sgZoneBorder = true;
      fc.add(border);

      /* Label nur bei aktiver Zone */
      if (isActive) {
        var label = new fabric.Text(zone.name, {
          left: zone.left + 8, top: zone.top + 6,
          fontSize: 10, fill: stroke, fontFamily: 'Arial, sans-serif',
          selectable: false, evented: false, _sgZoneBorder: true,
        });
        label._sgZoneBorder = true;
        fc.add(label);
      }
    });
  }

  /* Clip-Path für eine Zone */
  function buildClip(zone) {
    /* SVG-Pfad-Clip für Sonderformen (z.B. Servierbrett, organische Formen) */
    if (zone.shape === 'svg-path' && zone._svgPathD) {
      /* Fabric normalisiert Pfad-Koordinaten (Mittelpunkt → 0,0).
         pathOffset speichert den Original-Mittelpunkt im SVG-Koordinatensystem.
         Damit der Clip korrekt auf dem Canvas liegt:
         canvas-Mitte = pathOffset × scale                                    */
      var sx = zone._svgScaleX || 1;
      var sy = zone._svgScaleY || 1;
      var cp = new fabric.Path(zone._svgPathD, {
        absolutePositioned: true,
        scaleX:  sx,
        scaleY:  sy,
        originX: 'center',
        originY: 'center',
      });
      cp.left = cp.pathOffset.x * sx;
      cp.top  = cp.pathOffset.y * sy;
      return cp;
    }
    if (zone.shape === 'oval') {
      return new fabric.Ellipse({
        left: zone.cx, top: zone.cy,
        rx: zone.width / 2 - 4, ry: zone.height / 2 - 4,
        originX: 'center', originY: 'center',
        absolutePositioned: true,
      });
    }
    return new fabric.Rect({
      left: zone.left + 4, top: zone.top + 4,
      width: zone.width - 8, height: zone.height - 8,
      rx: zone.rx, ry: zone.rx,
      absolutePositioned: true,
    });
  }

  /* ── Hilfsfunktion: ist eine CSS-Farbe rötlich? ────────── */
  function isReddishColor(color) {
    if (!color || color === 'none') return false;
    if (color === 'red') return true;
    var hex = color.replace('#', '');
    if (hex.length === 3) hex = hex[0]+hex[0]+hex[1]+hex[1]+hex[2]+hex[2];
    if (hex.length === 6) {
      var r = parseInt(hex.substr(0,2), 16);
      var g = parseInt(hex.substr(2,2), 16);
      var b = parseInt(hex.substr(4,2), 16);
      return r > 150 && r > g * 2 && r > b * 2;
    }
    return false;
  }

  /* ── SVG-Pfad vorladen für Sonderform-ClipPath ──────────
     Wird bei boot() sofort gestartet (fire-and-forget).
     Trägt _svgPathD + _svgScaleX/Y in jede Zone mit shape:'svg-path' ein.
     buildClip() nutzt die Daten sobald sie da sind.
  ─────────────────────────────────────────────────────── */
  function preloadZonePaths(svgUrl, zones, W, H, fc) {
    var svgZones = zones.filter(function (z) { return z.shape === 'svg-path'; });
    if (!svgZones.length || !svgUrl) return;

    fetch(svgUrl)
      .then(function (r) { return r.text(); })
      .then(function (svgText) {
        var parser = new DOMParser();
        var doc    = parser.parseFromString(svgText, 'image/svg+xml');
        var svgEl  = doc.querySelector('svg');
        if (!svgEl) return;

        /* ViewBox auslesen */
        var vb    = svgEl.getAttribute('viewBox') || '';
        var parts = vb.split(/[\s,]+/);
        var vbW   = parseFloat(parts[2]) || W;
        var vbH   = parseFloat(parts[3]) || H;

        /* Roten Pfad (Gravurzone) suchen */
        var allPaths = doc.querySelectorAll('path');
        var zonePath = null;
        allPaths.forEach(function (el) {
          if (zonePath) return;
          var stroke = el.getAttribute('stroke') || '';
          var fill   = el.getAttribute('fill')   || '';
          if (isReddishColor(stroke) || isReddishColor(fill)) zonePath = el;
        });
        /* Fallback: erster Pfad */
        if (!zonePath && allPaths.length) zonePath = allPaths[0];
        if (!zonePath) return;

        var d = zonePath.getAttribute('d');
        if (!d) return;

        /* Skalierungsfaktoren berechnen und in jede svg-path-Zone eintragen */
        svgZones.forEach(function (zone) {
          zone._svgPathD  = d;
          zone._svgScaleX = W / vbW;
          zone._svgScaleY = H / vbH;
        });

        /* Bereits auf dem Canvas liegende Objekte bekommen den korrekten SVG-Clip-Pfad
           (betrifft Objekte die vor dem async-Fetch erstellt wurden und noch Rect-Clip haben) */
        if (fc) {
          var firstZone = svgZones[0];
          fc.getObjects().forEach(function (obj) {
            if (obj.clipPath && !obj._sgZoneBorder) {
              obj.clipPath = buildClip(firstZone);
            }
          });
          fc.requestRenderAll();
        }
      })
      .catch(function () { /* Fallback: Rect-Clip bleibt aktiv */ });
  }

  /* Objekt auf neue Zone verschieben */
  function moveToZone(obj, zone, mode, type, fc) {
    obj.set({ left: zone.cx, top: zone.cy });
    obj.setCoords();
  }

  /* ── Zonen-Auswahl UI aufbauen ─────────────────────── */
  function buildZoneSelector(zones, activeIdx, onChange) {
    var container = document.getElementById('sg-zone-section');
    var btnsWrap  = document.getElementById('sg-zone-btns');
    if (!container || !btnsWrap) return;

    /* Nur anzeigen wenn mehrere Zonen */
    if (zones.length < 2) { container.style.display = 'none'; return; }
    container.style.display = '';

    zones.forEach(function (zone, i) {
      var btn = document.createElement('button');
      btn.type      = 'button';
      btn.className = 'sg-zone-btn' + (i === activeIdx ? ' sg-zone-btn--active' : '');
      btn.textContent = zone.name;
      btn.dataset.idx = i;
      btn.addEventListener('click', function () {
        document.querySelectorAll('.sg-zone-btn').forEach(function (b) {
          b.classList.remove('sg-zone-btn--active');
        });
        this.classList.add('sg-zone-btn--active');
        onChange(parseInt(this.dataset.idx, 10));
      });
      btnsWrap.appendChild(btn);
    });
  }

  /* ── Farb-Selektor aufbauen (Windlicht) ─────────────────────────────────
     cfg.colors = [{ key, label, hexOut, hexIn }]
       key    – eindeutiger String, z.B. 'schwarz-gold'
       label  – Anzeigename, z.B. 'Schwarz/Gold'
       hexOut – Außenfarbe als HEX-Farbe (für Swatch)
       hexIn  – Innenfarbe als HEX-Farbe (für Swatch-Rand)
     onChange(key) wird bei Farb-Wechsel aufgerufen.
     Rendert in #sg-color-selector. Section #sg-color-section wird sichtbar.
  ──────────────────────────────────────────────────────────────────────── */
  function buildColorSelector(cfg, defaultKey, onChange) {
    var container = document.getElementById('sg-color-selector');
    if (!container || !cfg.colors || !cfg.colors.length) return;
    var section = document.getElementById('sg-color-section');
    if (section) section.style.display = '';

    var html = '';
    cfg.colors.forEach(function (c) {
      var active   = (c.key === defaultKey);
      var hexOut   = c.hexOut || '#333333';
      var hexIn    = c.hexIn  || '#999999';
      var isWhite  = hexOut.toLowerCase().indexOf('f5f5') !== -1 || hexOut === '#fff' || hexOut === '#ffffff';
      // Label aufteilen: "Schwarz/Rot" → "Schwarz" + "Rot"
      var parts    = (c.label || c.key).split('/');
      var labelLine = parts.length === 2
        ? '<span style="display:block;color:#888">' + parts[0] + '</span><span style="display:block;font-weight:700;color:#222">' + parts[1] + '</span>'
        : (c.label || c.key);
      html += '<button type="button"' +
              ' class="sg-color-btn' + (active ? ' sg-color-btn--active' : '') + '"' +
              ' data-key="' + c.key + '" title="' + (c.label || c.key) + '">' +
              // Außenkreis = Glasfarbe, Innenkreis = Gravurfarbe
              '<span class="sg-color-swatch' + (isWhite ? ' sg-color-swatch--white-out' : '') + '"' +
              ' style="background:' + hexOut + '">' +
              '<span class="sg-color-swatch__in" style="background:' + hexIn + '"></span>' +
              '</span>' +
              '<span class="sg-color-label">' + labelLine + '</span>' +
              '</button>';
    });
    container.innerHTML = html;

    container.querySelectorAll('.sg-color-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        container.querySelectorAll('.sg-color-btn').forEach(function (b) {
          b.classList.remove('sg-color-btn--active');
        });
        this.classList.add('sg-color-btn--active');
        if (onChange) onChange(this.dataset.key);
      });
    });
  }

  /* ═══════════════════════════════════════════════════════
     HINTERGRUND
  ═══════════════════════════════════════════════════════ */
  function loadBg(url, W, H, cb) {
    if (!url) { cb(null); return; }
    var isRemote = /^https?:\/\//i.test(url);
    fabric.Image.fromURL(url, function (img) {
      if (!img || !img.width) { cb(null); return; }
      var scale = Math.max(W / img.width, H / img.height);
      img.set({ scaleX: scale, scaleY: scale, left: W/2, top: H/2,
                originX: 'center', originY: 'center' });
      cb(img);
    }, isRemote ? { crossOrigin: 'anonymous' } : {});
  }

  /* ═══════════════════════════════════════════════════════
     TEXT
  ═══════════════════════════════════════════════════════ */

  /* ═══════════════════════════════════════════════════════
     KONTUR-CANVAS: Offscreen-Rendering mit destination-out.
     Stroke (sw×2 breit) malen, dann Buchstaben-Inneres
     ausschneiden → nur der sw-Rahmen AUSSERHALB bleibt.
     Auf eigenem Canvas → kein Schaden am Holz-Hintergrund.
  ═══════════════════════════════════════════════════════ */
  function buildKonturCanvas(text, fontFamily, fontSize) {
    var oc   = document.createElement('canvas');
    var octx = oc.getContext('2d');
    var sw   = 4;   /* Rahmenstärke außen (innen × 2 Gesamtstroke) */
    var pad  = sw + 6;
    var fontDecl = 'normal 400 ' + fontSize + 'px ' + fontFamily;

    octx.font = fontDecl;
    var m = octx.measureText(text);
    oc.width  = Math.ceil(m.width) + pad * 2;
    oc.height = Math.ceil(fontSize * 1.5) + pad * 2;

    /* Nach Größen-Setzen: Canvas-State zurückgesetzt → neu setzen */
    octx.font         = fontDecl;
    octx.textBaseline = 'alphabetic';

    var tx = pad;
    var ty = Math.ceil(fontSize * 1.1) + pad;

    /* Schritt 1: Breiten Stroke malen (sw innen + sw außen = sw×2 gesamt) */
    octx.strokeStyle = BURN_CSS;
    octx.lineWidth   = sw * 2;
    octx.lineJoin    = 'round';
    octx.lineCap     = 'round';
    octx.strokeText(text, tx, ty);

    /* Schritt 2: Buchstaben-Inneres mit destination-out wegschneiden */
    octx.globalCompositeOperation = 'destination-out';
    octx.fillStyle = 'rgba(0,0,0,1)';
    octx.fillText(text, tx, ty);
    /* octx.globalCompositeOperation bleibt 'destination-out' –
       spielt keine Rolle, Canvas wird nicht weiter benutzt */

    return oc;
  }

  /* buildNameText: callback-basiert.
     Normal  → fabric.Text, onDone sofort gerufen.
     Kontur  → buildKonturCanvas → fabric.Image, onDone nach img.onload. */
  function buildNameText(text, zone, mode, ts, makeClip, onDone) {
    var maxW      = zone.width  * 0.88;
    var maxH      = zone.height * 0.90;
    var textAlign = ts.align || 'center';
    var pad       = zone.width * 0.04;

    /* Startposition immer Zonenmitte — originX immer 'center' für
       konsistente left/top-Koordinaten beim Verschieben und Neubauen.
       textAlign steuert nur die Ausrichtung innerhalb der Textbox. */
    var posX    = zone.cx;
    var originX = 'center';

    function finalize(obj) {
      applyHandles(obj);
      obj.sgText     = text;
      obj.sgIsKontur = ts.outline;
      onDone(obj);
    }

    /* Kontur nur für einzeiligen Text */
    var isMultiline = text.indexOf('\n') !== -1;
    if (ts.outline && !isMultiline) {
      var oc    = buildKonturCanvas(text, ts.fontFamily, ts.fontSize);
      var scale = Math.min(1, maxW / oc.width);
      var url   = oc.toDataURL('image/png');

      var tmpImg    = new Image();
      tmpImg.onload = function () {
        var obj = new fabric.Image(tmpImg, {
          originX:     originX,
          originY:     'center',
          left:        posX,
          top:         zone.cy,
          scaleX:      scale,
          scaleY:      scale,
          hoverCursor: 'move',
          clipPath:    makeClip(),
        });
        finalize(obj);
      };
      tmpImg.src = url;

    } else {
      var fs  = ts.fontSize;
      var obj = new fabric.Text(text, {
        fontFamily:  ts.fontFamily,
        fontSize:    fs,
        textAlign:   textAlign,
        originX:     originX,
        originY:     'center',
        hoverCursor: 'move',
        clipPath:    makeClip(),
        fill:        BURN_CSS,
        stroke:      '',
        strokeWidth: 0,
        paintFirst:  'fill',
        lineHeight:  ts.lineHeight || 1.25,
      });

      /* Auto-Größe: passt Schrift an bis Text in Zone passt (Breite + Höhe) */
      while ((obj.width > maxW || obj.height > maxH) && fs > 8) {
        fs -= 1;
        obj.set({ fontSize: fs });
      }
      obj.set({ left: posX, top: zone.cy });
      obj.setCoords();
      finalize(obj);
    }
  }

  function applyPreset(obj, preset, zone, mode) {
    var cx = zone.cx;
    var cy = { top: 0.22, center: 0.50, bottom: 0.73 }[preset] || 0.50;
    obj.set({ left: cx, top: zone.top + zone.height * cy });
    obj.setCoords();
  }

  function buildEmoji(char, zone, mode, makeClip) {
    var size = Math.min(zone.width, zone.height) * 0.36;
    var em = new fabric.Text(char, {
      fontFamily: 'serif', fontSize: size * 0.65, fill: BURN_CSS2,
      left: zone.cx, top: zone.cy,
      originX: 'center', originY: 'center',
      hoverCursor: 'move', clipPath: makeClip(),
    });
    applyHandles(em);
    return em;
  }

  /* ═══════════════════════════════════════════════════════
     PIXEL-PROCESSING: Weiß entfernen + Gravur-Braun

     Wichtig: Bild wird VOR der Verarbeitung auf MAX_PX
     herunterskaliert. Sonst Absturz bei großen Fotos
     (Handyfoto 4000×3000 = 48 MB Pixel-Daten).
  ═══════════════════════════════════════════════════════ */
  var MAX_PX = 800;   /* max. Kantenlänge für Pixel-Processing */

  function applyBurnPixels(htmlImg) {
    /* ── Schritt 1: Zielgröße berechnen (max MAX_PX px) ── */
    var origW  = htmlImg.naturalWidth  || htmlImg.width  || 400;
    var origH  = htmlImg.naturalHeight || htmlImg.height || 400;
    var scale  = Math.min(1, MAX_PX / Math.max(origW, origH));
    var w      = Math.max(1, Math.round(origW * scale));
    var h      = Math.max(1, Math.round(origH * scale));

    var oc  = document.createElement('canvas');
    var ctx = oc.getContext('2d');
    oc.width  = w;
    oc.height = h;

    try {
      /* ── Schritt 2: Bild skaliert einzeichnen ─────────── */
      ctx.drawImage(htmlImg, 0, 0, w, h);

      /* ── Schritt 3: Pixel-Daten holen ─────────────────── */
      var imgData = ctx.getImageData(0, 0, w, h);
      var d       = imgData.data;

      /* ── Schritt 4: Pixel verarbeiten ─────────────────── */
      for (var i = 0; i < d.length; i += 4) {
        var r = d[i], g = d[i+1], b = d[i+2], a = d[i+3];

        /* Bereits transparent: überspringen */
        if (a < 10) continue;

        var lum    = 0.299*r + 0.587*g + 0.114*b;
        var chroma = Math.max(r, g, b) - Math.min(r, g, b);

        /* Weiß / Hellgrau / Papierhintergrund → transparent */
        if (lum > WHITE_THRESH && chroma < CHROMA_MAX) {
          d[i + 3] = 0;
          continue;
        }

        /* Farbige oder dunkle Pixel → Gravur-Farbe
           dark: 0 = hell (kaum sichtbar), 1 = schwarz (voller Effekt)
           Potenz-Kurve: Details in Mitteltönen besser erhalten        */
        var dark = Math.pow(Math.max(0, 1 - lum / 255), 0.65);
        if (BURN_IS_GLASS) {
          /* Glasgravur: immer weiß, Alpha proportional zur Dunkelheit */
          d[i]     = 255;
          d[i + 1] = 255;
          d[i + 2] = 255;
          d[i + 3] = Math.min(255, Math.round(Math.pow(dark, 0.55) * a));
        } else {
          /* Holzbrand: dunkle Pixel → Gravur-Braun, helle → leicht getönt */
          d[i]     = Math.round(BURN_R * dark + 220 * (1 - dark));
          d[i + 1] = Math.round(BURN_G * dark + 180 * (1 - dark));
          d[i + 2] = Math.round(BURN_B * dark + 140 * (1 - dark));
          d[i + 3] = Math.min(255, Math.round(a * (dark * 0.8 + 0.2)));
        }
      }

      ctx.putImageData(imgData, 0, 0);
      return oc.toDataURL('image/png');

    } catch (e) {
      /* CORS oder sonstiger Fehler → Fallback */
      console.warn('[sg-designer] Pixel-Processing fehlgeschlagen:', e.message);
      return null;
    }
  }

  function loadAndBurnImage(url, crossOrigin, onDone) {
    /* Lade-Hinweis anzeigen */
    setStatus('', 'Bild wird verarbeitet …');

    var tmp = new Image();
    if (crossOrigin) tmp.crossOrigin = 'anonymous';

    tmp.onload = function () {
      /* setTimeout(0): Browser-UI kurz atmen lassen bevor schwere Berechnung */
      setTimeout(function () {
        var processed = applyBurnPixels(tmp);
        setStatus('', '');   /* Hinweis wieder löschen */

        if (processed) {
          fabric.Image.fromURL(processed, onDone);
        } else {
          /* Fallback: Canvas war tainted (file://-Protokoll oder CORS).
             globalCompositeOperation:'multiply' → Weiß verschwindet im Hintergrund,
             dunkle Linien bleiben sichtbar — kein getImageData nötig, funktioniert
             auf file:// und in Produktion (https) greift ohnehin applyBurnPixels. */
          fabric.Image.fromURL(url, function (img) {
            /* Glas: 'screen' macht dunkle Linien auf hellem Glas sichtbar
               Holz: 'multiply' lässt weißen Hintergrund in Holz verschwinden */
            img.set({ globalCompositeOperation: BURN_IS_GLASS ? 'screen' : 'multiply' });
            onDone(img);
          }, crossOrigin ? { crossOrigin: 'anonymous' } : {});
        }
      }, 0);
    };

    tmp.onerror = function () {
      setStatus('err', 'Bild konnte nicht geladen werden.');
      console.warn('[sg-designer] Bild nicht ladbar:', url);
    };

    tmp.src = url;
  }

  function burnSVGObjects(objects) {
    objects.forEach(function (o) {
      if (o.fill  && o.fill  !== 'none') o.set({ fill:   'rgb('+BURN_R+','+BURN_G+','+BURN_B+')' });
      if (o.stroke && o.stroke !== 'none') o.set({ stroke: 'rgb('+BURN_R+','+BURN_G+','+BURN_B+')' });
    });
  }

  /* ═══════════════════════════════════════════════════════
     MOTIVE laden
  ═══════════════════════════════════════════════════════ */
  function loadImgMotiv(url, zone, mode, makeClip, cb) {
    loadAndBurnImage(url, /^https?:\/\//i.test(url), function (img) {
      placeMotiv(img, zone, mode);
      img.set({ hoverCursor: 'move', clipPath: makeClip() });
      applyHandles(img);
      cb(img);
    });
  }

  function loadSVGMotiv(url, zone, mode, makeClip, cb) {
    fabric.loadSVGFromURL(url, function (objects, options) {
      burnSVGObjects(objects);
      var grp = fabric.util.groupSVGElements(objects, options);
      placeMotiv(grp, zone, mode);
      grp.set({ hoverCursor: 'move', opacity: 0.88, clipPath: makeClip() });
      applyHandles(grp);
      cb(grp);
    });
  }

  /* Einheitliche Handles: nur Ecken (prop. Skalierung) + Drehen, kein Verzerren */
  function applyHandles(obj, extra) {
    obj.set(Object.assign({
      selectable: true, hasControls: true, hasBorders: true,
      lockRotation: false, lockScalingX: false, lockScalingY: false,
      lockUniScaling: true,
      cornerColor: '#C8391A', cornerSize: 10, transparentCorners: false,
    }, extra || {}));
    obj.setControlsVisibility({ ml: false, mr: false, mt: false, mb: false });
  }

  function placeMotiv(obj, zone, mode) {
    var maxS  = Math.min(zone.width, zone.height) * 0.45;
    var scale = maxS / Math.max(obj.width || 1, obj.height || 1);
    obj.set({ scaleX: scale, scaleY: scale, left: zone.cx, top: zone.cy,
              originX: 'center', originY: 'center' });
    obj.setCoords();
  }

  function placeCenter(obj, zone, fill) {
    var maxS  = Math.min(zone.width, zone.height) * fill;
    var scale = maxS / Math.max(obj.width || 1, obj.height || 1);
    obj.set({ scaleX: scale, scaleY: scale, left: zone.cx, top: zone.cy,
              originX: 'center', originY: 'center' });
    obj.setCoords();
  }

  /* ═══════════════════════════════════════════════════════
     DRAG – innerhalb aktiver Zone einschränken
     activeZoneFn: Funktion die aktuelle Zone zurückgibt
     (nicht Wert, damit bei Zonenwechsel immer aktuell)
  ═══════════════════════════════════════════════════════ */
  function attachDrag(fc, obj, activeZoneFn) {
    obj.on('moving', function () {
      var zone = activeZoneFn();
      var bnd  = obj.getBoundingRect(true);
      var hw   = bnd.width  / 2;
      var hh   = bnd.height / 2;

      if (zone.shape === 'oval') {
        var a  = zone.width  / 2 - hw;
        var b  = zone.height / 2 - hh;
        if (a > 0 && b > 0) {
          var dx   = obj.left - zone.cx;
          var dy   = obj.top  - zone.cy;
          var dist = (dx*dx)/(a*a) + (dy*dy)/(b*b);
          if (dist > 1) {
            var angle = Math.atan2(dy/b, dx/a);
            obj.set({ left: zone.cx + a*Math.cos(angle), top: zone.cy + b*Math.sin(angle) });
          }
        }
      } else {
        obj.set({
          left: Math.max(zone.left+hw, Math.min(zone.left+zone.width -hw, obj.left)),
          top:  Math.max(zone.top +hh, Math.min(zone.top +zone.height-hh, obj.top)),
        });
      }
      obj.setCoords();
    });
  }

  /* ═══════════════════════════════════════════════════════
     UI-HELFER
  ═══════════════════════════════════════════════════════ */
  function showSections(mode) {
    tog('sg-name-section',  mode === 'name' || mode === 'name_motiv' || mode === 'logo');
    tog('sg-motiv-section', mode === 'motiv' || mode === 'name_motiv');
    tog('sg-logo-section',  mode === 'logo');
  }
  function toggleTextControls(mode) {
    tog('sg-text-controls', mode === 'name' || mode === 'name_motiv' || mode === 'logo');
  }
  function tog(id, show) {
    var el = document.getElementById(id);
    if (el) el.style.display = show ? '' : 'none';
  }
  function highlightOpt(radio) {
    document.querySelectorAll('.sg-option').forEach(function (l) { l.classList.remove('sg-option--active'); });
    radio.closest('.sg-option').classList.add('sg-option--active');
  }

  /* ═══════════════════════════════════════════════════════
     PREIS
  ═══════════════════════════════════════════════════════ */
  function updatePrice(cfg, mode, textActive, selectedColor, isBeidseitig) {
    var apMode = (cfg.aufpreise && cfg.aufpreise[mode]) ? cfg.aufpreise[mode] : 0;
    var apBeid = (isBeidseitig && cfg.aufpreise && cfg.aufpreise.beidseitig)
                 ? cfg.aufpreise.beidseitig : 0;
    var el = document.getElementById('sg-total-price');
    if (el) el.textContent = fmtEur(cfg.basePrice + apMode + apBeid);

    var labels = {
      ohne:       'Ohne Gravur',
      name:       'Nur Text',
      motiv:      'Nur Motiv',
      name_motiv: 'Text & Motiv',
      logo:       textActive ? 'Text & Eigenes Motiv' : 'Eigenes Motiv',
    };
    var p = document.getElementById('sg-prop-option');
    if (p) p.value = labels[mode] || mode;

    /* Bei Logo-Mode: Motiv-Property auf "Eigenes Motiv" setzen (sichtbar im Warenkorb) */
    var propMotiv = document.getElementById('sg-prop-motiv');
    if (propMotiv && mode === 'logo') {
      propMotiv.value = 'Eigenes Motiv';
    }

    /* Shopify-Variante im Formular aktualisieren → korrekter Preis im Warenkorb
       2D variantMap (Windlicht: { farbKey: { name: id, motiv: id, ... } })
       1D variantMap (Vesperbretter: { name: id, motiv: id, ... }) ← rückwärtskompatibel */
    if (cfg.variantMap) {
      var vid;
      if (selectedColor && cfg.variantMap[selectedColor]) {
        /* 2D: Farbe × Gravur-Mode */
        vid = cfg.variantMap[selectedColor][mode];
      } else {
        /* 1D: nur Gravur-Mode */
        vid = cfg.variantMap[mode];
      }
      if (vid) {
        var idInput = document.querySelector('#sg-form input[name="id"]');
        if (idInput) idInput.value = vid;
      }
    }
  }
  function r(c)      { return (c/100).toFixed(0); }
  function fmtEur(c) { return (c/100).toFixed(2).replace('.', ',') + '\u00a0\u20ac'; }

  /* ═══════════════════════════════════════════════════════
     CLOUDINARY + WARENKORB
  ═══════════════════════════════════════════════════════ */
  /* Canvas-Preview (dataURL) hochladen */
  function uploadCld(dataUrl, cfg) {
    return new Promise(function (resolve, reject) {
      var fd = new FormData();
      fd.append('file', dataUrl);
      fd.append('upload_preset', cfg.cloudinaryPreset);
      fd.append('folder', 'schwarzwald-gravur');
      fetch('https://api.cloudinary.com/v1_1/' + cfg.cloudinaryCloud + '/image/upload',
        { method: 'POST', body: fd })
        .then(function (r) { return r.json(); })
        .then(function (d) { d.secure_url ? resolve(d.secure_url) : reject(); })
        .catch(reject);
    });
  }

  /* Original-Datei (File-Objekt) hochladen – volle Qualität */
  function uploadCldFile(file, cfg) {
    return new Promise(function (resolve, reject) {
      var fd = new FormData();
      fd.append('file', file);
      fd.append('upload_preset', cfg.cloudinaryPreset);
      fd.append('folder', 'schwarzwald-gravur/originals');
      fetch('https://api.cloudinary.com/v1_1/' + cfg.cloudinaryCloud + '/image/upload',
        { method: 'POST', body: fd })
        .then(function (r) { return r.json(); })
        .then(function (d) { d.secure_url ? resolve(d.secure_url) : reject(d); })
        .catch(reject);
    });
  }
  function cartSubmit(form, btn) {
    btn.textContent = 'Wird hinzugefügt …';
    fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
      .then(function (r) { if (!r.ok) throw r.status; return r.json(); })
      .then(function () { window.location.href = '/cart'; })
      .catch(function (e) {
        console.error('[sg-designer] Warenkorb:', e);
        btn.disabled = false; btn.textContent = 'In den Warenkorb';
        setStatus('err', 'Fehler – bitte nochmals versuchen.');
      });
  }
  function setStatus(type, msg) {
    var el = document.getElementById('sg-upload-status');
    if (el) { el.textContent = msg; el.className = 'sg-upload-status sg-upload-status--' + type; }
  }

})();
